import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { add, remove } from '../../action/wishList';
import { useAuth0 } from '../../context/auth0';
import {
    selectWishListEntries,
} from '../../reducer/wishList';
import { action_openModalLikeListing } from './../data/isOpenModalLikeListing';
import { SESSION_STORAGE_KEYS } from '../../../constants';
import { invalidateUserCache } from '../../command/userCache';

const WishlistBridge = () => {
    const { isAuthenticated } = useAuth0();
    const dispatch = useDispatch();
    const entries = useSelector(selectWishListEntries);

    // Almost identical to
    // wp-content/themes/app-theme/assets/o/js/widget/component/AddToWishList/AddToWishList.js
    // Custom event shape is defined inside wp-content/themes/app-theme/views/templates/template-page-results.twig
    // For quick reference: `window.dispatchEvent(new CustomEvent('addtowishlist', { detail: { listingId } }));`
    const callback = useCallback((customEvent) => {
        const listingId = customEvent.detail.listingId
        if (!listingId) return

        const sanitizedListingId = parseInt(listingId, 10);
        const isFavorite = entries.some((e) => e === sanitizedListingId)
        // TODO: add delayed request after authentication
        if (!isAuthenticated) {
            const wishListActions = JSON.parse(
                sessionStorage.getItem(SESSION_STORAGE_KEYS.PENDING_ACTIONS) || '[]'
            );
            wishListActions.push(add(sanitizedListingId));
            sessionStorage.setItem(
                SESSION_STORAGE_KEYS.PENDING_ACTIONS,
                JSON.stringify(wishListActions)
            );
            dispatch(action_openModalLikeListing());
            return;
        }

        if (isFavorite) {
            dispatch(remove(sanitizedListingId));
            invalidateUserCache();
        } else {
            dispatch(add(sanitizedListingId));
            invalidateUserCache();
            // Assicurati che dataLayer sia definito prima di usarlo
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'addToWishlist',
                    ecommerce: {
                        addToWishlist: {
                            products: [
                                {
                                    id: listingId, // TODO
                                },
                            ],
                        },
                    },
                });
            }
        }
    }, [dispatch, entries, isAuthenticated])

    useEffect(() => {
        window.addEventListener("addtowishlist", callback);

        return () => {
            window.removeEventListener("addtowishlist", callback);
        }
    }, [callback])

    useEffect(() => {
        window.dispatchEvent(new CustomEvent('wishlistchanged', { detail: { entries } }));
    }, [entries])

    return <div id='wishlist-bridge'></div>;
}

export default WishlistBridge;
export { WishlistBridge };